const createSuccessResponse = (res) => {
  return { status: "success", data: res };
};

const createFailResponse = (res) => {
  return { status: "failure", data: res };
};

const createErrorResponse = (err) => {
  return { status: "error", data: err };
};

export { createSuccessResponse, createFailResponse, createErrorResponse };
